import { useState, useEffect, useCallback } from "react";
import { useAuthContext } from "../context/AuthContext";
import { ROLES } from "../constants";
import { countAllHocSinh, countHocSinhByLop } from "../services/hocSinhService";
import { countChuaDiemDanh, countVangKhongPhep } from "../services/diemDanhService";

export const useBadge = () => {
  const { user, hasRole } = useAuthContext();
  const [badges, setBadges] = useState({});

  const fetchBadges = useCallback(async () => {
    if (!user) return;

    const newBadges = {};

    try {
      const lopId = user.maLopCN;

      // ===== GVCN / GV_PHU: Điểm danh =====
      if (hasRole(ROLES.GVCN) || hasRole(ROLES.GV_PHU)) {
        if (lopId) {
          const tongHS = await countHocSinhByLop(lopId);
          const daDiemDanh = await countChuaDiemDanh(lopId);
          const chuaDiemDanh = tongHS - daDiemDanh;
          
          if (chuaDiemDanh > 0) {
            newBadges['/diem-danh'] = {
              count: chuaDiemDanh,
              type: 'warning',
              label: `${chuaDiemDanh} HS chưa điểm danh`
            };
          }

          const vangKP = await countVangKhongPhep(lopId);
          if (vangKP > 0) {
            newBadges['/diem-danh'] = {
              count: vangKP,
              type: 'error',
              label: `${vangKP} HS vắng không phép`
            };
          }
        }
      }

      // ===== GVCN: Nhập điểm =====
      if (hasRole(ROLES.GVCN)) {
        newBadges['/nhap-diem'] = { count: 0, type: 'info', label: 'Đã nhập đủ' };
      }

      // ===== GVCN + ADMIN: Đánh giá =====
      if (hasRole(ROLES.GVCN) || hasRole(ROLES.ADMIN)) {
        newBadges['/danh-gia-cuoi-ky'] = { count: 0, type: 'info', label: 'Đã đánh giá hết' };
      }

      // ===== ADMIN: Quản lý HS =====
      if (hasRole(ROLES.ADMIN)) {
        const tongHS = await countAllHocSinh();
        newBadges['/quan-ly-hoc-sinh'] = {
          count: tongHS,
          type: 'info',
          label: `${tongHS} học sinh`
        };
      }

      // ===== ADMIN + TRUONG_NGANH: Báo cáo =====
      if (hasRole(ROLES.ADMIN) || hasRole(ROLES.TRUONG_NGANH)) {
        newBadges['/bao-cao'] = { count: 0, type: 'info', label: 'Chưa có báo cáo mới' };
      }

    } catch (error) {
      console.error("Lỗi lấy badge:", error);
    }

    setBadges(newBadges);
  }, [user, hasRole]);

  // ===== FETCH LẦN ĐẦU + LẮNG NGHE SỰ KIỆN =====
  useEffect(() => {
    fetchBadges();

    // Lắng nghe sự kiện cập nhật badge từ các page
    const handleRefreshBadge = () => {
      fetchBadges();
    };

    window.addEventListener('refreshBadge', handleRefreshBadge);

    return () => {
      window.removeEventListener('refreshBadge', handleRefreshBadge);
    };
  }, [fetchBadges]);

  return badges;
};